var Messages = require('./messages');
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

require('./lang/en');

var require_method = require;

var container = {

  messages: {},

  /**
   * Set messages for language
   *
   * @param {string} lang
   * @param {object} rawMessages
   * @return {void}
   */
  _set: function(lang, rawMessages) {
    this.messages[lang] = rawMessages;
  },

  /**
   * Set message for given language's rule.
   *
   * @param {string} lang
   * @param {string} attribute
   * @param {string|object} message
   * @return {void}
   */
  _setRuleMessage: function(lang, attribute, message) {
    this._load(lang);
    if (message === undefined) {
      message = this.messages[lang].def;
    }

    this.messages[lang][attribute] = message;
  },

  /**
   * Load messages (if not already loaded)
   *
   * @param  {string} lang
   * @return {void}
   */
  _load: function(lang) {
    // if (!this.messages[lang]) {
      try {
        var rawMessages = {
          accepted: getLabel('386937', ':attribute必须是可接受的'),
          alpha: getLabel('386936', ':attribute只能包含字母'),
          alpha_dash: getLabel('386939', ':attribute只能包含字母,连字符和下划线'),
          alpha_num: getLabel('386940', ':attribute只能包含字母和数字'),
          between: getLabel('386941', ':attribute的(大小,长度等)只能在:min和:max之间'),
          confirmed: getLabel('386942', ':attribute确认不一致'),
          email: getLabel('386943', ':attribute格式不正确'),
          date: getLabel('386944', ':attribute日期格式错误'),
          def: getLabel('386945', ':attribute属性错误'),
          digits: getLabel('386946', ':attribute必须是:digits位小数'),
          different: getLabel('386947', ':attribute和:different必须不同'),
          'in': getLabel('386948', '选择的:attribute无效'),
          integer: getLabel('386949', ':attribute必须是一个整数'),
          min:{
            numeric: getLabel('386950', ':attribute不能小于:min'),
            string: getLabel('386951', ':attribute长度不能小于:min')
          },
          max: {
            numeric: getLabel('386952', ':attribute不能大于:max'),
            string: getLabel('386953', ':attribute长度不能大于:max')
          },
          not_in: getLabel('386954', '所选的:attribute无效'),
          numeric: getLabel('386955', ':attribute必须是一个数字'),
          present: getLabel('386956', ':attribute字段必须存在（但可以是空的）'),
          required: getLabel('386957', ':attribute 未填写'),
          required_if: getLabel('386958', '当:other是:value时,:attribute不能为空'),
          same: getLabel('386959', ':attribute和:same必须一致'),
          size: {
            numeric: getLabel('386960', ':attribute必须等于:size'),
            string: getLabel('386962', ':attribute的长度必须等于:size')
          },
          string: getLabel('386963', ':attribute必须是一个字符串'),
          url: getLabel('386943', ':attribute格式不正确'),
          regex: getLabel('386943', ':attribute格式不正确'),
          attributes: {}
        }
        this._set(lang, rawMessages);
      } catch (e) {}
    // }
  },

  /**
   * Get raw messages for language
   *
   * @param  {string} lang
   * @return {object}
   */
  _get: function(lang) {
    this._load(lang);
    return this.messages[lang];
  },

  /**
   * Make messages for given language
   *
   * @param  {string} lang
   * @return {Messages}
   */
  _make: function(lang) {
    this._load(lang);
    return new Messages(lang, this.messages[lang]);
  }

};

module.exports = container;



// WEBPACK FOOTER //
// ./comMobx/wea-form/validatorjs/src/lang.js